import {Component, Input, OnInit, AfterViewInit, Output, EventEmitter} from '@angular/core';
import {ConfService} from '../conf.service';
import {GrantPermissionDialogComponent, LeftpanelComponent, LoaderWithProgressComponent} from '../leftpanel/leftpanel.component';
import {MatDialog, MatDialogRef} from '@angular/material';
import {ConnecttocrudService} from '../connecttocrud.service';
import {environment} from '../../environments/environment';
import {PromotionSettingsComponent} from './promotion-settings/promotion-settings.component';

export interface NavItem {
    displayName: string;
    disabled?: boolean;
    iconName: string;
    route?: string;
    index: number;
    select: boolean;
    override: boolean;
    children?: NavItem[];
}


@Component({
    selector: 'app-api-dependencies',
    templateUrl: './api-dependencies.component.html',
    styleUrls: ['./api-dependencies.component.scss']
})
export class ApiDependenciesComponent implements OnInit, AfterViewInit {

    @Input() targetPartner;
    @Input() targetPkey;
    @Input() targetAccount;
    @Input() targetAPI;
    @Input() targetAPIVersion;
    @Input() apiDeploymentStatus = [];
    @Output() apiDependencies: EventEmitter<any> = new EventEmitter<any>();
    @Output() itemSelected: EventEmitter<any> = new EventEmitter<any>();
    @Output() apiPromoted: EventEmitter<any> = new EventEmitter<any>();
    @Output() showLogs: EventEmitter<any> = new EventEmitter<any>();
    apiDependenciesList = [];
    databases: any;
    targetDatabases = [];
    selectedDatatypeFilter: any;
    partner = localStorage.getItem('partner');
    account = localStorage.getItem('account');
    @Input() type;
    @Input() renderType: any;
    entityType: any;
    dependentAPIs: any;
    expanded = true;
    expandChildren = false;
    allChecked = [true, false];
    selectedAPIs = [];
    overrideAPIs = [];
    userPermission = [];
    navItems = [];
    loading = true;

    users: any = {
        name: '',
        completed: false,
        color: 'primary',
        subtasks: []
    };
    defaultUsers: any = {
        name: '',
        completed: false,
        color: 'primary',
        subtasks: []
    };
    userFound = false;

    constructor(public confPost: ConfService, public platform: LeftpanelComponent, public _service: ConnecttocrudService, private dialog: MatDialog) {
    }

    async ngOnInit() {
        const shortName = this.targetPartner.split('-');
        Promise.resolve(this.getUsersForTarget(shortName[shortName.length - 1])).then(resp => {
            if (resp === 'success') {
                this.navItems = [];
                if (this.type === 'DATAACCESS') {
                    this.entityType = 'Data Access API';
                    this.confPost.getDependenciesForEntities(this.partner, this.account, this.targetAPI, this.targetAPIVersion, this.targetPartner, this.targetAccount).subscribe(response => {
                        if (response) {
                            this.dependentAPIs = response;
                            this.navItems.push(this.setDependenciesForEntity(this.dependentAPIs, JSON.parse(JSON.stringify(this.defaultUsers))));
                            this.apiDependencies.emit(this.apiDependenciesList);
                            //this.getDatabases();
                            this.loading = false;
                        }
                    });
                } else {
                    this.confPost.getDependenciesForExecutors(this.partner, this.account, this.targetAPI, this.targetAPIVersion, this.targetPartner, this.targetAccount).subscribe(response => {
                        if (response) {
                            this.dependentAPIs = response;
                            this.navItems.push(this.setDependenciesForExecutor(this.dependentAPIs, JSON.parse(JSON.stringify(this.defaultUsers))));
                            this.apiDependencies.emit(this.apiDependenciesList);
                            //this.getDatabases();
                            this.loading = false;
                        }
                    });
                }
            } else {
                this.platform.openSnackBar('No users associated to this partner Environment. API(s) cannot be promoted.', 'Error', {
                    duration: 3000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            }
        }, error => {
            this.platform.openSnackBar('Unknown error occurred while retrieving users on target environment. Please try again later.', 'Error', {
                duration: 3000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        });

    }

    getUsersForTarget(partnerName) {
        return new Promise((resolve, reject) => {
            this._service.getItemswithParameter('v1', environment.accessPartner, environment.accessPartner, 'users', 'partner.in=' + partnerName).subscribe(data => {
                if (data) {
                    let users: any;
                    users = data;
                    for (const user of users) {
                        if (user['status']) {
                            for (const e of user['environments']) {
                                if (e['name'] === this.targetPartner) {
                                    this.users.subtasks.push(
                                        {name: user['user'], completed: false, email: user['email'], color: 'primary'}
                                    );
                                    this.users.subtasks[this.users.subtasks.length - 1]['preSelected'] = user['email'] === localStorage.getItem('signInEmail') || user['user'] === 'admin-' + partnerName;
                                    this.users.subtasks[this.users.subtasks.length - 1]['completed'] = this.users.subtasks[this.users.subtasks.length - 1]['preSelected'];
                                }
                            }
                        }
                    }
                    this.userFound = this.users.subtasks.length > 0;
                    this.defaultUsers = JSON.parse(JSON.stringify(this.users));
                    resolve('success');
                } else {
                    resolve('failure');
                }
            }, error => {
                reject(error);
            });
        });
    }

    async getDatabases() {
        if (this.platform.databases !== null && this.platform.databases !== undefined) {
            this.databases = this.platform.databases;
            this.getDatabaseTypeForDatabaseName(this.apiDependenciesList[0].database);
        } else {
            await this.confPost.getDatabases(localStorage.getItem('partner')).toPromise().then(async databases => {
                    await this.platform.updateIsNoSQLForMongo(databases);
                    this.databases = this.platform.databases;
                    this.getDatabaseTypeForDatabaseName(this.apiDependenciesList[0].database);
                },
                error => {
                    this.platform.handleErrorGracefully(error, 'Error while getting list of databases. Please try again after sometime.');
                });
        }
    }

    getDatabaseTypeForDatabaseName(val) {
        // if (this.databases.hasOwnProperty('databaseDetails')) {
        //   this.databases.databaseDetails.filter(items => {
        //     if (items.database_name === val) {
        //       this.selectedDatatypeFilter = items.database_type;
        //     }
        //   });
        // } else {
        this.databases.filter(items => {
            if (items.database_name === val) {
                this.selectedDatatypeFilter = items.database_type;
            }
        });
        // }
        this.getPartnerDatabases();
    }

    getPartnerDatabases() {
        this.targetDatabases = [];
        return new Promise((resolve, reject) => {
            this.confPost.getDatabasesForPartner(this.targetPartner, this.targetPkey).subscribe(response1 => {
                if (response1 && response1 !== null && response1 !== undefined && response1.status && response1.status === 200) {
                    if (response1.body && response1.body !== null && response1.body !== undefined) {
                        if (response1.body && response1.body !== null && response1.body !== undefined) {
                            let databases: any;
                            databases = response1.body;
                            databases.forEach(db => {
                                if (db && db !== null && db !== undefined) {
                                    if (db['database_type'] === this.selectedDatatypeFilter) {
                                        this.targetDatabases.push(db);
                                    }
                                }
                            });
                            resolve('success');
                        } else {
                            resolve('failed');
                        }
                    } else {
                        resolve('failed');
                    }
                } else {
                    resolve('failed');
                }
            }, error => {
                resolve('failed');
                this.platform.handleErrorGracefully(error, 'Error while retrieving target partner\'s databases.');
            });
        });
    }

    setDependenciesForEntity(dependentAPI, users) {
        this.apiDependenciesList.push(dependentAPI.entity);
        this.apiDeploymentStatus.push({
            deploying: false,
            deployed: 'loading',
        });
        const menuItem = {
            displayName: dependentAPI.entity.entityname + ' (' + dependentAPI.entity.version + ')',
            iconName: 'fa fa-table',
            route: 'devfestfl',
            index: this.apiDependenciesList.length - 1,
            select: true,
            override: false,
            users: users
        };
        this.userPermission.push({users: users, default: true});
        this.selectedAPIs.push(this.apiDependenciesList.length - 1);
        if (dependentAPI.uniqueDependencies.DAAS.length) {
            menuItem['children'] = [];
            for (const api of dependentAPI.uniqueDependencies.DAAS) {
                this.apiDependenciesList.push(api);
                this.selectedAPIs.push(this.apiDependenciesList.length - 1);
                this.userPermission.push({users: users, default: true});
                this.apiDeploymentStatus.push({
                    deploying: false,
                    deployed: 'loading',
                });
                menuItem['children'].push({
                    displayName: api.entityname + ' (' + api.version + ')',
                    iconName: 'fa fa-table',
                    route: 'devfestfl',
                    index: this.apiDependenciesList.length - 1,
                    select: true,
                    override: false,
                    users: users
                });

            }
        }
        return menuItem;
    }

    getIconForExecutor (type) {
        if (type === 'SQLQUERY') {
            return 'fa fa-database';
        } else if (type === 'TESTSUITE') {
            return 'fa fa-check-circle-o';
        } else if (type === 'WORKFLOW') {
            return 'fa fa-sitemap';
        } else {
            return 'fa fa-link';
        }
    }

    setDependenciesForExecutor(dependentAPI, users) {
        if (dependentAPI['apiExecutor']) {
            this.apiDependenciesList.push(dependentAPI['apiExecutor']);
            this.apiDeploymentStatus.push({
                deploying: false,
                deployed: 'loading',
            });
        }
        const menuItem = {
            displayName: dependentAPI['apiExecutor'].executor_name + ' (' + dependentAPI['apiExecutor'].executor_version + ')',
            iconName: this.getIconForExecutor(dependentAPI['apiExecutor'].executor_type),
            route: 'devfestfl',
            index: this.apiDependenciesList.length - 1,
            select: true,
            override: false,
            users: users
        };
        this.userPermission.push({users: users, default: true});
        this.selectedAPIs.push(this.apiDependenciesList.length - 1);
        if (dependentAPI.uniqueDependencies.DAAS.length || dependentAPI.uniqueDependencies.DECISION.length ||
            dependentAPI.uniqueDependencies.THIRDPARTY.length || dependentAPI.uniqueDependencies.QUERY.length ||
            dependentAPI.uniqueDependencies.SQLQUERY.length || dependentAPI.uniqueDependencies.WORKFLOW.length ||
            dependentAPI.uniqueDependencies.BUSINESSLOGIC.length) {
            menuItem['children'] = [];
            let executorDependencies = [];
            executorDependencies = executorDependencies.concat(dependentAPI.uniqueDependencies.DECISION, dependentAPI.uniqueDependencies.THIRDPARTY, dependentAPI.uniqueDependencies.QUERY,
                dependentAPI.uniqueDependencies.SQLQUERY, dependentAPI.uniqueDependencies.WORKFLOW, dependentAPI.uniqueDependencies.BUSINESSLOGIC);
            for (const api of dependentAPI.uniqueDependencies.DAAS) {
                this.apiDependenciesList.push(api);
                this.userPermission.push({users: users, default: true});
                this.selectedAPIs.push(this.apiDependenciesList.length - 1);
                this.apiDeploymentStatus.push({
                    deploying: false,
                    deployed: 'loading',
                });
                menuItem['children'].push({
                    displayName: api.entityname + ' (' + api.version + ')',
                    iconName: 'fa fa-table',
                    route: 'devfestfl',
                    index: this.apiDependenciesList.length - 1,
                    select: true,
                    override: false,
                    users: users
                });
            }
            for (const api of executorDependencies) {
                this.apiDependenciesList.push(api);
                this.userPermission.push({users: users, default: true});
                this.selectedAPIs.push(this.apiDependenciesList.length - 1);
                this.apiDeploymentStatus.push({
                    deploying: false,
                    deployed: 'loading',
                });
                menuItem['children'].push({
                    displayName: api.executor_name + ' (' + api.executor_version + ')',
                    iconName: this.getIconForExecutor(api.executor_type),
                    route: 'devfestfl',
                    index: this.apiDependenciesList.length - 1,
                    select: true,
                    override: false,
                    users: users
                });
            }
        }
        return menuItem;
    }


    checkForExistingAPI(APIName, APIVersion) {
        return new Promise((resolve, reject) => {
            return Promise.resolve(this.platform.CheckForExistingEntityOrExecutorWithParams(this.targetPartner, this.targetAccount, this.targetPkey, APIName, APIVersion)).then(resp => {
                // if (this.type === 'DATAACCESS' || this.type === 'SQLQUERY') {
                //     await this.getPartnerDatabases(loaderDialog);
                //     resolve('success');
                //     this.checkAuthenticityAndGetDatabasesCompleted = false;
                //     loaderDialog.close();
                // } else {
                //     this.checkAuthenticityAndGetDatabasesCompleted = false;
                //     loaderDialog.close();
                //     resolve('success');
                // }
                resolve(false);
                //this.isAPIAlreadyExists = false;
            }, error => {
                if (error.status === 'already exists') {
                    // this.platform.openSnackBar('An API with the provided name and version already exists in the target partner.', 'Error', {
                    //   duration: 10000,
                    //   verticalPosition: 'top',
                    //   horizontalPosition: 'center'
                    // });
                    resolve(true);
                    //this.isAPIAlreadyExists = true;
                    // if (this.platform.existingEntity !== null && this.platform.existingEntity !== undefined && this.platform.existingEntity !== '') {
                    //     this.existingAPI = this.platform.existingEntity;
                    // } else if (this.platform.existingExecutor !== null && this.platform.existingExecutor !== undefined && this.platform.existingExecutor !== '') {
                    //     this.existingAPI = this.platform.existingExecutor;
                    // }
                    // resolve('already exists');

                } else if (error.status === 'failed') {
                    //this.isAPIAlreadyExists = null;
                    this.platform.openSnackBar('Error while checking API availability in target partner. Please try again after sometime.', 'Error', {
                        duration: 10000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                    reject('failed');
                }
                // await this.getPartnerDatabases(loaderDialog);
                // this.checkAuthenticityAndGetDatabasesCompleted = false;
                // loaderDialog.close();
            });
        });
    }

    ngAfterViewInit() {

    }

    getDependentAPIs() {
        this.confPost.getDependenciesForEntities(this.partner, this.account, this.targetAPI, this.targetAPIVersion, this.targetPartner, this.targetAccount).subscribe(response => {
            if (response) {
                this.dependentAPIs = response;
            }
        });
    }

    onItemSelected(index) {
        this.itemSelected.emit(index);
    }

    updatePermissionObject (itemObj) {
        this.userPermission[itemObj.index].default = false;
        this.userPermission[itemObj.index].users = itemObj.users;

        if (itemObj.index === 0) {
            this.navItems[0].users = itemObj.users;
        } else {
            const childIndex = this.navItems[0].children.findIndex(value => value['displayName'] === itemObj.displayName);
            this.navItems[0].children[childIndex].users = itemObj.users;
        }
    }

    updateAllCompleteParent(itemObj) {
        const index = itemObj.type === 'select' ? 0 : 1;
        if (itemObj.type === 'select') {
            this.selectedAPIs = [];
        } else if (itemObj.type === 'override') {
            this.overrideAPIs = [];
        }

        if (itemObj.items) {
            this.allChecked[index] = this.updateAllComplete(itemObj.type, itemObj.items);
            this.navItems = itemObj.items;
        } else {
            this.allChecked[index] = this.updateAllComplete(itemObj.type);
        }

    }

    updateAllComplete(type, item = this.navItems[0]) {
        if (item[type]) {
            if (type === 'select') {
                this.selectedAPIs.push(item.index);
            } else {
                this.overrideAPIs.push(item.index);
            }
            if (item.children && item.children.length) {
                let updatedChildren = 0;
                for (const child of item.children) {
                    if (this.updateAllComplete(type, child)) {
                        updatedChildren++;
                    }
                }
                return (updatedChildren === item.children.length) ? true : false;
            } else {
                return true;
            }
        } else {
            if (item.children && item.children.length) {
                for (const child of item.children) {
                    this.updateAllComplete(type, child);
                }
            }
            return false;
        }

        // this.allChecked[index] = this.navItems[0].children && this.menus[index].submenu.every(t => t.checked);
    }

    someCompleteParent(type, index) {
        //this.selectedAPIs = [];
        return this.someComplete(type, index);
    }

    someComplete(type, index, item = this.navItems[0]): boolean {
        if (!item[type]) {
            if (item.children && item.children.length) {
                let completedChildren = 0;
                for (const child of item.children) {
                    if (this.someComplete(type, index, child)) {
                        completedChildren++;
                        return true;
                    }
                }
                // return (completedChildren === item.children.length) ? true : false;
            } else {
                return false;
            }
        } else {
            return true && !this.allChecked[index];
        }

        // if (this.menus[index].submenu == null) {
        //     return false;
        // }
        // return this.menus[index].submenu.filter(t => t.checked).length > 0 && !this.allChecked[index];
    }

    setAllParent(checked, type) {
        if (type === 'select' && checked) {
            this.selectedAPIs = [];
        } else if (type === 'override' && checked) {
            this.overrideAPIs = [];
        }
        this.setAll(checked, type);
    }

    setAll(checked: boolean, type, item = this.navItems[0]) {
        const index = type === 'select' ? 0 : 1;
        this.allChecked[index] = checked;
        item[type] = checked;
        if (type === 'select' && checked) {
            this.selectedAPIs.push(item.index);
        }
        if (type === 'override' && checked) {
            this.overrideAPIs.push(item.index);
        }
        if (item.children && item.children.length) {
            for (const child of item.children) {
                this.setAll(checked, type, child);
            }
        }
        // if (this.menus[index].submenu == null) {
        //     return;
        // }
        // this.menus[index].submenu.forEach(t => t.checked = checked);
    }

    promoteAPI() {
        this.apiPromoted.emit({
            selectedAPIs: this.selectedAPIs,
            overrideAPIs: this.overrideAPIs,
            apiDependenciesList: this.apiDependenciesList,
            permissionList: this.userPermission
        });
    }

    configurePromotionSettings() {
        const dialogRef = this.dialog.open(PromotionSettingsComponent, {
            height: '75%',
            width: '60%',
            data: {
                type: 'master',
                users: JSON.parse(JSON.stringify(this.defaultUsers)),
                overrideAPIs: JSON.parse(JSON.stringify(this.overrideAPIs)),
                apiDependenciesList:  JSON.parse(JSON.stringify(this.apiDependenciesList)),
                allChecked: this.allChecked[1],
                navItems: JSON.parse(JSON.stringify(this.navItems))
            }
        });

        dialogRef.afterClosed().subscribe(async result => {
            if (result === 'configure') {
                this.defaultUsers = JSON.parse(JSON.stringify(dialogRef.componentInstance.users));
                // this.apiDependenciesList = dialogRef.componentInstance.apiDependenciesList;
                this.overrideAPIs = dialogRef.componentInstance.overrideAPIs;
                this.allChecked[1] = dialogRef.componentInstance.allChecked;
                this.navItems = dialogRef.componentInstance.navItems;
                this.userPermission.forEach((api, index) => {
                    if (api.default) {
                        api.users = JSON.parse(JSON.stringify(this.defaultUsers));

                        if (index === 0) {
                            this.navItems[0].users = JSON.parse(JSON.stringify(this.defaultUsers));
                        } else {
                            const childIndex = this.navItems[0].children.findIndex(value => value['index'] === index);
                            this.navItems[0].children[childIndex].users = JSON.parse(JSON.stringify(this.defaultUsers));
                        }
                    }
                });
            }
        });
    }



    expandAll() {
        this.expanded = true;
        this.expandChildren = true;
    }

    collapseAll() {
        this.expanded = false;
        this.expandChildren = false;
    }

    showLog(val) {
        this.showLogs.emit(val);
    }

}
